<style scoped>
.lblItem {
  color: #aaa;
  display: block;
  margin-top: 10px;
}
.image-preview-container {
  height: 200px;
  overflow: hidden;
  text-align: center;
  background: #f2f2f2;
}
.image-preview-container > img {
  height: 100%;
  width: auto;
  margin: 0 auto;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>

<template>
    <app-layout class="directory-page-template">
        <Affix :offset-top="60">
            <Card shadow :padding="10" :style="{borderRadius: '0'}">
                <div class="ivu-input-wrapper ivu-input-type">
                    <i class="ivu-icon ivu-icon-search ivu-input-icon ivu-input-icon-normal"></i>
                    <input autocomplete="off" v-model="keyword" @keyup.13="searchDirectory(keyword)" spellcheck="false" type="text" placeholder="Search..." class="ivu-input">
                </div>
            </Card>
        </Affix>
        <Row type="flex" justify="center">
            <Col v-if="setLoader" style="text-align:center;padding:10px 0">
              <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Col>
            <Col v-if="filter" :span="24" v-for="(item, k) in dataSubDirectory.items" :key="k">
                <Card shadow :style="{borderRadius: '0', cursor: 'pointer', borderTop: '1px solid #F2F2F2', minHeight: '60px'}" :padding="0">
                    <div @click="setViewItem(item)" class="resources-item-header" :style="{padding: '10px 10px 8px'}">
                        <Icon type="chevron-right" style="float:right;line-height:40px"></Icon>
                        <a><Avatar size="large" icon="location" :style="{backgroundColor: '#aaa', float:'left', marginRight: '10px'}" /></a>
                        <p class="truncate" style="font-size:.8rem;padding-right:20px">
                            <b>{{item.title}}</b>
                        </p>
                    </div>
                </Card>
            </Col>
            <Col v-if="!filter" :span="24" v-for="(item, k) in dataDirectory" :key="k">
                <Card shadow :style="{borderRadius: '0', cursor: 'pointer', borderTop: '1px solid #F2F2F2', minHeight: '60px'}" :padding="0">
                    <div @click="onSelectItem(item.slug, item.type, null)" class="resources-item-header" :style="{padding: '10px 10px 8px'}">
                        <Icon type="chevron-right" style="float:right;line-height:40px"></Icon>
                        <a v-if="item.type === 'world_directory'"><Avatar size="large" :src="item.image.small" :style="{float:'left', marginRight: '10px'}" /></a>
                        <a v-else><Avatar size="large" icon="location" :style="{backgroundColor: '#aaa', float:'left', marginRight: '10px'}" /></a>
                        <p class="truncate" style="font-size:.8rem;padding-right:20px">
                            <b>{{item.category}}</b>
                        </p>
                    </div>
                </Card>
            </Col>
        </Row>
        <div v-if="viewItem.show">
            <ModalHolder :title="viewItem.data.title" m-top="0" :is-show="viewItem.show">
                <template v-if="viewItem.data.data" slot="mcontent">
                    <div id="map" style="height: 150px;background: #f0f0f0;"></div>
                    <p style="padding:3px 8px;background:#fff;border:1px solid #f0f0f0;">
                      <b>{{viewItem.data.title}}</b></p>
                    <span class="lblItem">Address:</span> {{viewItem.data.data.address}}<br/>
                    <span class="lblItem">Email:</span> {{viewItem.data.data.email}}<br/>
                    <span class="lblItem">Website:</span> {{viewItem.data.data.website}}<br/>
                    <span class="lblItem">Phone Number:</span> {{viewItem.data.data.phone_number}}<br/>
                    <span class="lblItem">Hotline:</span> {{viewItem.data.data.hotline}}<br/>
                    <span class="lblItem">Representative:</span> {{viewItem.data.data.representative}}<br/>
                    <span class="lblItem">Note:</span> {{viewItem.data.data.note}}
                </template>
                <template slot="mfooter">
                    <Button type="default" @click="viewItem.show = false">Close</Button>
                    <Button @click="bookmarkDirectory(viewItem)" :type="(viewItem.bookmarked) ? 'primary':'ghost'" style="float:left">
                      <i v-if="viewItem.bookmarked" class="fas fa-bookmark"></i>
                      <i v-else class="far fa-bookmark"></i> {{(viewItem.bookmarked) ? 'Bookmarked':'Bookmark'}}</Button>
                </template>
            </ModalHolder>
        </div>
    </app-layout>
</template>

<script>
import ModalHolder from '@/components/ModalHolderComponent'

export default {
  name: 'DirectoryComponent',
  components: {
    ModalHolder
  },
  mounted () {
    this.slugSetter()
  },
  data () {
    return {
      type: 'world_directory',
      filter: null,
      keyword: null,
      viewItem: {
        data: {},
        show: false
      }
    }
  },
  watch: {
    $route: function (n, o) {
      if (n) {
        this.filter =
          'filter' in n.query && n.query.filter ? n.query.filter : null
        if (this.filter) this.onSelectItem(this.filter, this.type)
      }
    }
  },
  computed: {
    mapLoaded: {
      get () {
        return this.$store.state.gmapLoaded
      }
    },
    dataDirectory: {
      get () {
        if (this.type === 'world_directory') { return this.directory.worldDirectory.data }
        if (this.type === 'recruiting_agencies') { return this.directory.recruitmentAgency.data }
        if (this.type === 'regional_offices') { return this.directory.regionalOffices.data }
      }
    },
    dataSubDirectory: {
      get () {
        if (this.type === 'world_directory') { return this.subDirectory.worldDirectory.data }
        if (this.type === 'recruiting_agencies') { return this.subDirectory.recruitmentAgency.data }
        if (this.type === 'regional_offices') { return this.subDirectory.regionalOffices.data }
      }
    },
    directory: {
      get () {
        return this.$store.state.directory.directory
      }
    },
    subDirectory: {
      get () {
        return this.$store.state.directory.subDirectory
      }
    },
    setLoader: {
      get () {
        if (
          this.$store.state.directory.subDirectory.worldDirectory.isLoading ||
          this.$store.state.directory.subDirectory.recruitmentAgency
            .isLoading ||
          this.$store.state.directory.subDirectory.regionalOffices.isLoading ||
          this.$store.state.directory.directory.worldDirectory.isLoading ||
          this.$store.state.directory.directory.recruitmentAgency.isLoading ||
          this.$store.state.directory.directory.regionalOffices.isLoading
        ) { return true }
        return false
      }
    }
  },
  methods: {
    bookmarkDirectory (item) {
      this.$store
        .dispatch('feed/bookmarkItem', { item: item.data, type: this.section })
        .then(
          res => {
            if (!item.bookmarked) {
              item.data.bookmark_id = res.id
              item.data.bookmarked = 1
            } else {
              delete item.data.bookmark_id
              item.data.bookmarked = 0
            }
          },
          err => {}
        )
    },
    setViewItem (item) {
      this.viewItem.data = item
      this.viewItem.show = true
      console.log(item)
      setTimeout(() => {
        var latlng = item.data.geolatlng
        var uluru = {
          lat: parseFloat(latlng.split(',')[0]),
          lng: parseFloat(latlng.split(',')[1])
        }
        var mMap = document.getElementById('map')
        var map = new google.maps.Map(document.getElementById('map'), {
          zoom: 4,
          center: uluru
        })
        var marker = new google.maps.Marker({
          position: uluru,
          map: map
        })
      }, 1000)
    },
    searchDirectory (k) {
      return this.directory.worldDirectory.data.indexOf(k) !== -1
    },
    slugSetter () {
      this.type =
        'slug' in this.$route.query && this.$route.query.slug
          ? this.$route.query.slug
          : 'world_directory'
      this.filter =
        'filter' in this.$route.query && this.$route.query.filter
          ? this.$route.query.filter
          : null

      if (this.filter) this.onSelectItem(this.filter, this.type)

      this.$store.dispatch('directory/getdirectory', { type: this.type })
    },
    onSelectItem (slug, type) {
      let mfilter =
        '&filter=directory_type_slug:' + type + ';category_slug:' + slug
      this.$router.push({ query: { slug: type, filter: slug } })
      this.$store.dispatch('directory/getSubItems', {
        type: this.type,
        query: mfilter
      })
    }
  }
}
</script>
